<template>
  <div class="wrapper">
    <div class="input_box">
      <input class="cellItem_inp" type="text" placeholder="请输入邮箱" maxlength="30" v-model="email" />
    </div>
    <span class="tips">请输入新邮箱，点击提交后系统将重新发送电子发票</span>
    <div :class="['btn',email?'':'unC']" @click="submit">
        <span class="btnSpan">提交</span>
    </div>

  </div>
</template>

<style scoped>
.wrapper{
    background-color:#f3f4f6;
    width: 750px;
    flex-direction: column;
}
.input_box {
  margin-top: 14px;
  margin-bottom: 28px;
  background-color: #fff;
  padding: 0 28px;
  height: 100px;
}
.cellItem_inp {
  height: 100px;
  font-size: 28px;
  color: rgba(51, 51, 51, 1);
}
.tips {
    width: 750px;
    display: flex;
  font-size: 26px;
  color: rgba(153, 153, 153, 1);
  line-height: 36px;
  margin: 0 28px 80px;
}
.btn {
  width: 694px;
  display: flex;
  margin: 0 28px;
  height: 76px;
  line-height: 76px;
  border-radius: 8px;
  background-color:#0087ff;
  color:#fff;
  font-size:32px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.btnSpan{
    color:#fff;
   font-size:32px;
}
.unC {
  background-color: #dadada;
}
</style>
<script>
    import {repeatReceipt} from '../../utils/api';
    import { mapState } from "vuex";
    import util from '../../utils/util';

    export default {
        data: function() {
            return {
                id:'',
                email:''
            };
        },
        computed: {
            ...mapState({
                    common: state => state.common
            })
        },
        created() {
            this.email = '';
            let query = this.$route.query;
            this.id = query.id;
            this.email = query.email;
        },
        methods: {

            isEmail(str){
                var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
                    ///^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
                return reg.test(str);
            },
            submit(){
                console.log("in submit")
                if(!this.email){
                    return;
                }
                if(!this.isEmail(this.email)){
                    util.showToast("请输入合法的电子邮箱")
                    return
                }
                let params ={
                    receiptId:this.id,
                    email:this.email
                }
                util.showLoading("正在提交开票数据…")
                repeatReceipt(params).then(res => {
                    util.hideLoading();
                    console.log(res)
                    if(res.res.code == '10000'){
                        util.showToast("提交成功，发票将在5分钟内发送至您的邮箱，请及时查收。")
                    }else{
                         util.showToast(res.res.msg)
                    }
                    setTimeout(() => {
                        this.$router.go(-1)
                    }, 2000)
                })
            },
        },
        filters: {
        }
    }
</script>